import request from '@/apis';
import { string } from 'zod';
export enum EventStatus {
  UPCOMING = 'UPCOMING',
  ONGOING = 'ONGING',
  ENDED = 'ENDED',
}
export const participated = (data: {
  airDropProjectId: string;
  plartForm: string;
  walletAddress: string;
}) => {
  return request<{
    airdropProjectUserRecordDTO: {
      uid: string;
      thirdId: string;
      airDropProjectId: string;
      walletAddress: string;
      price: string;
      finish: boolean;
      createdTime: string;
      updatedTime: string;
    };
  }>({
    url: '/api/mc-api/airdrop/participated',
    data,
    method: 'post',
  });
};

export interface AirdropProjectDTOS {
  id: string;
  name: string;
  coin: string;
  totalPrize: string;
  winnerCounts: string;
  status: EventStatus;
  participationStartTime: string;
  participationEndTime: string;
  policies: string;
  participateContent: string;
  claimContent: string;
  termsConditions: string;
  requirements: [
    {
      platform: Platform;
      flowLink: string;
      appPackage?: string;
      // user_name?: string;
      // user_id?: string;
      type: TwitterTaskType | '';
      userName?: string;
      link: string;
      content?: string;
      remark?:string
    },
  ];
}
export enum Platform {
  TWITTER = 'Twitter',
  DISCORD = 'Discord',
  TELEGRAM = 'Telegram',
}

export enum TwitterTaskType {
  'Retweet' = '0',
  'Follow' = '1',
  'Post' = '2',
}

export const query = (data: {
  status?: EventStatus;
  partnerName?: string;
  prevId: string;
  nextId: string;
  pageSize: number;
}) => {
  return request<{
    airdropProjectDTOS: AirdropProjectDTOS[];
    totalSize: number;
  }>({
    url: '/api/mc-api/airdrop/events/query',
    data,
    method: 'post',
  });
};
interface Requirements {
  platform: string;
  flowLink: string;
  appPackage: string;
  user_name: string;
  user_id: string;
}
export const history = (data: {
  prevId: string;
  nextId: string;
  pageSize?: number;
}) => {
  return request<{
    totalSize: number;
    airdropProjectUserRecordDTOList: {
      airdropProjectDTO: {
        id: string;
        name: string;
        coin: string;
        totalPrize: string;
        winnerCounts: string;
        status: string;
        participationStartTime: string;
        participationEndTime: string;
        requirements: Requirements[];
        policies: string;
        participateContent: string;
        claimContent: string;
        termsConditions: string;
      };
      id: string;
      name: string;
      coin: string;
      totalPrize: string;
      winnerCounts: string;
      status: string;
      participationStartTime: string;
      participationEndTime: string;
      requirements: {
        platform: string;
        flowLink: string;
        appPackage: string;
        user_name: string;
        user_id: string;
      }[];
      policies: string;
      participateContent: string;
      claimContent: string;
      termsConditions: string;
    }[];
    uid: string;
    thirdId: string;
    airDropProjectId: string;
    walletAddress: string;
    price: string;
    finish: boolean;
    createdTime: string;
    updatedTime: string;
  }>({
    url: '/api/mc-api/airdrop/participated/history',
    data,
    method: 'post',
  });
};

export const addWalletAddress = (data: {
  airDropProjectId: string;
  plartForm: string;
  walletAddress: string;
}) => {
  return request<{
    airdropProjectUserRecordDTO: {
      uid: string;
      thirdId: string;
      airDropProjectId: string;
      walletAddress: string;
      price: string;
      finish: boolean;
      createdTime: string;
      updatedTime: string;
    };
  }>({
    url: '/api/mc-api/airdrop/events/add-wallet-address',
    data,
    method: 'post',
  });
};
